import namespace from '@/store/namespace'
export default namespace('BandejaComun',{
    getters:[
        'GetDatosTramitesSolicitadosNet',
        'GetDatosPromocionesNet',
    ],
    actions:[
        'ObtenerTramitesSolicitudesNet',
        'ObtenerPromocionesNet',
    ],
    mutations:[
        'SetDatosTramitesSolicitadosNet',
        'SetDatosPromocionesNet',
    ]
})
